export const view10ImageOptions = {
  angle: 'view10',
  staticOptions: {
    HullColour: 1,
    BowSprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    BathingPlatform: 1,
    TeakOnBathingPlatform: 1,
    Wheel: 1,
    BoomCover: 1,
    CockpitTable: 1,
    Sprayhood: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: 'BathingPlatform'
    },
    {
      option: 'HullTreatment',
      dependency: null
    },
    {
      option: 'Deck',
      dependency: 'SelfTacker'
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'Wheel',
      dependency: null
    },
    {
      option: 'BoomCover',
      dependency: null
    },
    {
      option: 'CockpitTable',
      dependency: 'Wheel'
    },
    {
      option: 'Sprayhood',
      dependency: 'BoomCover'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X43MK2/views/view10.js